import React, { useEffect, useRef, useState } from 'react';
import './index.module.less';
import NavBar from '@components/NavBar';
import MapDetail from './MapDetail';
import { defaultPoint, isInIos } from '@helpers/Constants';
import BrowserHistory from '@helpers/BrowserHistory';
import { transformToBd09, transformToGcj02 } from '@utils/mapUtil';

import { hideLoading } from '@widgets/Loading';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import * as Cache from '@helpers/Cache';
import useUrlParams from '@helpers/useUrlParams';
import { ICenterPoint } from './constants';
import FridayService from '@services/friday';

//私有常量

//可抽离的逻辑处理函数/组件

let MapFrequentedPlace = (_props: IProps) => {
  //变量声明、解构
  const ContentRef = useRef(null);
  const urlParams = useUrlParams();

  //组件状态
  const [center, setCenter] = useState<ICenterPoint>(null);
  const [loading, setLoading] = useState(true);

  //网络IO

  //数据转换

  //逻辑处理函数
  // 初始化页面数据
  const getInitData = async () => {
    //编辑地点
    if (urlParams.actionType && urlParams.actionType === 'edit') {
      const editData = Cache.get(urlParams.placeUid);
      const point = JSON.parse(editData.region).points[0];
      const tempPoint = transformToBd09({ lng: point[0], lat: point[1] });
      setCenter(tempPoint);
      setLoading(false);
    } else if (urlParams.actionType && urlParams.actionType === 'add') {
      //获取定位信息(如果设备有历史定位，则使用历史定位，没有历史定位时使用默认位置为北京市定位
      const res = await Http.post(Api.GetPositionV1Realtime, {
        snCode: urlParams.snCode,
      }).catch(() => {
        setLoading(false);
      });
      const result = res ? res.data : null;
      let location = defaultPoint;
      if (result) {
        const tempPoint = transformToBd09({ lng: result?.longitude, lat: result?.latitude });
        location = tempPoint;
      }
      setCenter(location);
      setLoading(false);
    }
  };

  const handleBack = () => {
    /**
     * TODO
     * （暂时的解决办法）
     * 在 iOS 中含有地图组件的页面无法正常的返回上一页面，需要点击两次返回才能返回（第一次调用 BrowserHistory.goBack() 无效）
     * 因此，当判断环境为 iOS/iPhone 时，调用一次返回函数后，再次异步调用返回函数
     */
    BrowserHistory.goBack();
    if (isInIos) {
      setTimeout(() => {
        BrowserHistory.goBack();
      });
    }
  };

  const handleSave = () => {
    const data = ContentRef.current.save();
    const  points = data.points.map((item: any) => transformToGcj02({ lng: item[0], lat: item[1] }));
    const tempPoints = points.map((item: any) => [item.lng, item.lat]);

    if (urlParams.actionType && urlParams.actionType === 'edit') {
      Http.post(Api.PutMobileRegionStayV1, {
        uid: urlParams.placeUid,
        name: data.title,
        address: data.address,
        points: tempPoints,
      })
        .then(() => {
          hideLoading();
          handleBack();
        })
        .catch(() => {
          hideLoading();
        });
    } else if (urlParams.actionType && urlParams.actionType === 'add') {
      FridayService.addEvent(
        'real_time_location_more_location_settings_frequent_places_add_frequent_places_save_click',
      );
      Http.post(Api.PostMobileRegionStayV1, {
        snCode: urlParams.snCode,
        company: urlParams.company,
        name: data.title,
        address: data.address,
        points: tempPoints,
      })
        .then(() => {
          hideLoading();
          handleBack();
        })
        .catch(() => {
          hideLoading();
        });
    }
  };

  //组件Effect
  useEffect(() => {
    window.scrollTo(0, 0);
    getInitData();
    // eslint-disable-next-line
  }, []);

  return loading ? null : (
    <div
      style={{
        width: '100%',
        height: document.body.clientHeight * 0.77,
      }}
    >
      <NavBar
        title=" "
        transparent
        RightBtnComponent={
          <div
            styleName="nav-right-btn"
            className="flex flex-center"
            onClick={handleSave}
          >
            保存
          </div>
        }
        BackBtnComponent={
          <div
            styleName="nav-back-btn"
            className="flex flex-center"
            onClick={handleBack}
          >
            <i className="iconfont icon-tubiaoyanse" />
          </div>
        }
      />
      <MapDetail ref={ContentRef} centerPoint={center} urlParams={urlParams} />
    </div>
  );
};

//props类型定义
interface IProps {}

//prop-type定义，可选

export default MapFrequentedPlace;
